module.exports = __webpack_public_path__ + "img/brand.e8dabc5c.png";